import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledScrollableTooltipList = styled.div`
    max-height: 200px;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 8px 12px;
    ${mixins.setFontVariant("tooltip", colorsPalettes.carbon[0])};
    box-sizing: border-box;
    pointer-events: auto;
`;

export const StyledScrollableTooltipItem = styled.div`
    &:not(:last-child) {
        margin-bottom: 4px;
    }
`;
